import { render, staticRenderFns } from "./CentroUserRoles.vue?vue&type=template&id=4a670002"
import script from "./CentroUserRoles.vue?vue&type=script&lang=js"
export * from "./CentroUserRoles.vue?vue&type=script&lang=js"
import style0 from "./CentroUserRoles.vue?vue&type=style&index=0&id=4a670002&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports